import type { HelpFile } from '../../types/help'
import { SqlEditorDialogTestIds } from '../../../testids/SqlEditorDialogTestIds'

export const sqlEditorDialogHelp: HelpFile = {
  docPage: '/docs/admin/sql-attributes',
  texts: {
    [SqlEditorDialogTestIds.sqlEditorDialog]: 'Compose the SQL statement that resolves this attribute. Bound parameters are passed in as named placeholders.',
    [SqlEditorDialogTestIds.sqlParametersHint]: 'Refer to bound parameters with `:name` syntax. Available parameter names are listed above.',
    [SqlEditorDialogTestIds.sqlValidationError]: 'The query failed validation — see the message for details. Save is disabled until the query parses cleanly.',
    [SqlEditorDialogTestIds.sqlEditorApply]: 'Apply the query to the attribute and close the dialog. The query is re-validated on save.',
  },
}
